import { Injectable } from '@angular/core';
import { ModelService } from 'src/app/services/model.service';
import { BearerHttpService } from '../../services/bearer-http.service';
import { User } from 'src/app/entities/user.entity';
import { ConfigService } from 'src/app/app.config';
import { Observable } from 'rxjs';
import { map, retry } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class UserDetailService {

	constructor(
		private http: BearerHttpService,
		private modelService: ModelService
	) { }

	public removeImage(userData: User): Observable<any> {
		return this.http.Delete(ConfigService.REST_SERVER + '/api/deleteImage/user')
			.pipe(map(res => { this.modelService.getUser().userUpdatedSignal.emit(true); }));
	}

	public uploadImage(id: String, file: string): Observable<any> {
		return this.http.Post(ConfigService.REST_SERVER + '/api/upload/user/' + id, { img: file, id: id })
			.pipe(map(res => { this.modelService.getUser().userUpdatedSignal.emit(true); }));
	}
// peticion post, le mandamos la ruta con el user con el valor de su id, el idioma a modificar y nos subscribimos
	public updateLanguage(idioma:string, value:any):Observable<any>{
		value.idioma = idioma;
		return this.http.Post(ConfigService.REST_SERVER+'/api/updateLanguage/user/'+value.id, {lang:idioma}).pipe(map(res => { this.modelService.getUser().userUpdatedSignal.emit(true); }));
	}

	public update(userData: User): Observable<any> {

		userData['idioma'] = this.modelService.getLanguage().currentLanguage;
		return this.http.Post(ConfigService.REST_SERVER + '/api/user', userData)
			.pipe(map(res => { this.modelService.getUser().userUpdatedSignal.emit(true); }));
	}

	public getUser(userId: number): Observable<any> {
		return this.http.Get(ConfigService.REST_SERVER + '/api/user/' + userId)
			.pipe(map(res => { this.modelService.getUser().userUpdatedSignal.emit(true); }));
	}

	public getUser2(userId: any): Observable<any> {
		return this.http.Get(ConfigService.REST_SERVER + '/api/user/' + userId).pipe(retry(1));
	}

	public getProjectsCountUser(userId: any): Observable<any> {
		return this.http.Get(ConfigService.REST_SERVER + '/api/user/projectsCount/' + userId).pipe(retry(1));
	}

	// Elimina el usuario y sus proyectos.
	public deleteUser(userId: any): Observable<any> {
		return this.http.Delete(ConfigService.REST_SERVER + '/api/deleteUser/' + userId).pipe(retry(1));
	}

	// Pasa a estado Eliminado, pone el usario a estado '3' y añade o modifica el campo 'delete=true' en sus proyectos.
	public changeUserToDelete(userId: any): Observable<any> {
		return this.http.Delete(ConfigService.REST_SERVER + '/api/changeUserToDelete/' + userId).pipe(retry(1));
	}

	// Restaurar usuario con sus proyectos, el usuario debe estar en estado 3.
	public recoverUser(userId: any): Observable<any> {
		return this.http.Get(ConfigService.REST_SERVER + '/api/user/recover/' + userId).pipe(retry(1));
	}
}
